import { render, staticRenderFns } from "./CampaignAuthor.vue?vue&type=template&id=60ec9f55"
import script from "./CampaignAuthor.vue?vue&type=script&lang=js"
export * from "./CampaignAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports